module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-details', {
    ref: "userDetails",
    attrs: {
      "can-change-role": _vm.parentUserIsCarrier
    }
  }, [_c('div', {
    slot: "cropper"
  }, [(_vm.loggedInUserIsAdmin && _vm.accountUser.driver_profile) ? _c('photo-cropper', {
    attrs: {
      "name": "driver",
      "photo-storage-path": _vm.accountUser.driver_profile.photo_storage_path,
      "original-name": _vm.accountUser.driver_profile.photo_name,
      "original-data-uri": _vm.originalPhotoDataUri,
      "class-name": "profile-photo",
      "label-text": "Profile Photo"
    },
    model: {
      value: (_vm.photo),
      callback: function($$v) {
        _vm.photo = $$v
      },
      expression: "photo"
    }
  }) : (_vm.accountUser.driver_profile && _vm.accountUser.driver_profile.photo_storage_path) ? _c('div', {
    staticClass: "preview"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": ((_vm.accountUser.driver_profile.photo_storage_path) + "/256x256.jpg")
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.profile) ? _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material"
  }, [_c('h3', [_vm._v("Notification Settings")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-lg"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.notify_job_status),
      expression: "profile.notify_job_status"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-email",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.notify_job_status) ? _vm._i(_vm.profile.notify_job_status, null) > -1 : (_vm.profile.notify_job_status)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.profile.notify_job_status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.profile.notify_job_status = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.profile.notify_job_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.profile.notify_job_status = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-email"
    }
  }, [_vm._v("\n              Notify job status updates\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.notify_load_deliveries),
      expression: "profile.notify_load_deliveries"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-email-delivery",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.notify_load_deliveries) ? _vm._i(_vm.profile.notify_load_deliveries, null) > -1 : (_vm.profile.notify_load_deliveries)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.profile.notify_load_deliveries,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.profile.notify_load_deliveries = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.profile.notify_load_deliveries = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.profile.notify_load_deliveries = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-email-delivery"
    }
  }, [_vm._v("\n              Notify load deliveries\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.notify_job_completed),
      expression: "profile.notify_job_completed"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-job-completed",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.notify_job_completed) ? _vm._i(_vm.profile.notify_job_completed, null) > -1 : (_vm.profile.notify_job_completed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.profile.notify_job_completed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.profile.notify_job_completed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.profile.notify_job_completed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.profile.notify_job_completed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-job-completed"
    }
  }, [_vm._v("\n              Notify invoices and payments\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.notify_public_jobs),
      expression: "profile.notify_public_jobs"
    }],
    staticClass: "styled",
    attrs: {
      "id": "notify-public-jobs",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.notify_public_jobs) ? _vm._i(_vm.profile.notify_public_jobs, null) > -1 : (_vm.profile.notify_public_jobs)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.profile.notify_public_jobs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.profile.notify_public_jobs = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.profile.notify_public_jobs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.profile.notify_public_jobs = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "notify-public-jobs"
    }
  }, [_vm._v("\n              Receive email about public jobs\n            ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.editingOrCreateChildAdminAccount) ? _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('h3', [_vm._v("Admin System Access")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionLoadCheck),
      expression: "permissionLoadCheck"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-load-check",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionLoadCheck) ? _vm._i(_vm.permissionLoadCheck, null) > -1 : (_vm.permissionLoadCheck)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionLoadCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionLoadCheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionLoadCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionLoadCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-load-check"
    }
  }, [_vm._v("\n          Load Check\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionInvoices),
      expression: "permissionInvoices"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-invoices",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionInvoices) ? _vm._i(_vm.permissionInvoices, null) > -1 : (_vm.permissionInvoices)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionInvoices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionInvoices = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionInvoices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionInvoices = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-invoices"
    }
  }, [_vm._v("\n          Invoices\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionPayments),
      expression: "permissionPayments"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-payments",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionPayments) ? _vm._i(_vm.permissionPayments, null) > -1 : (_vm.permissionPayments)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionPayments,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionPayments = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionPayments = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionPayments = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-payments"
    }
  }, [_vm._v("\n          Payments\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionReports),
      expression: "permissionReports"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-reports",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionReports) ? _vm._i(_vm.permissionReports, null) > -1 : (_vm.permissionReports)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionReports,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionReports = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionReports = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionReports = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-reports"
    }
  }, [_vm._v("\n          Reports\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionUsers),
      expression: "permissionUsers"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-users",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionUsers) ? _vm._i(_vm.permissionUsers, null) > -1 : (_vm.permissionUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionUsers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-users"
    }
  }, [_vm._v("\n          Users\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionSettings),
      expression: "permissionSettings"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-system-settings",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionSettings) ? _vm._i(_vm.permissionSettings, null) > -1 : (_vm.permissionSettings)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionSettings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionSettings = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionSettings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionSettings = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-system-settings"
    }
  }, [_vm._v("\n          System Settings\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionAdministrator),
      expression: "permissionAdministrator"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-system-adminstrator",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionAdministrator) ? _vm._i(_vm.permissionAdministrator, null) > -1 : (_vm.permissionAdministrator)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionAdministrator,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionAdministrator = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionAdministrator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionAdministrator = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-system-adminstrator"
    }
  }, [_vm._v("\n          System Administrator\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('ladda-button', {
    staticClass: "btn btn-success",
    attrs: {
      "on-click": _vm.saveAccountUser
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Save")]), _vm._v(" "), _c('div', {
    staticClass: "decorative-divider"
  }), _vm._v(" "), (_vm.editingUser) ? _c('div', [(!_vm.accountUser.driver_profile) ? _c('span', [(_vm.accountUserDecorated.isEnabled) ? _c('ladda-button', {
    staticClass: "btn btn-sm m-b-sm btn-warning",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleDisableUser
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Disable User\n      ")]) : _c('ladda-button', {
    staticClass: "btn btn-sm m-b-sm btn-success",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleEnableUser
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Enable User\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.accountUserDecorated.isNotArchived) ? _c('ladda-button', {
    staticClass: "btn btn-sm m-b-sm btn-danger",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleRemoveUser
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete User\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-50"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-11638ada"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account-users/AccountUserForm.vue
// module id = 931
// module chunks = 0